/**
 * Which portal requests carry the practice header (AIC-463). Mirrors tracker-api's PRACTICE_ROUTE_PREFIXES
 * (services/tracker-api/src/practice/hook.ts); practiceRoutes.test.ts reads that file and pins the two as equal, so a
 * route added to the server's allowlist fails here until it is added to this one.
 *
 * The practice session's own start, list, reset and restore-spec routes are under an allowlisted prefix but run in
 * REAL scope: with the header the server answers 400 practice_header_not_allowed. They never carry it.
 */
export const PRACTICE_HEADER = "x-swtracker-practice";

export const PRACTICE_ROUTE_PREFIXES = [
  "/api/portal/specs",
  "/api/portal/assignments",
  "/api/portal/invites",
  "/api/portal/sessions",
  "/api/portal/results",
  "/api/portal/review-items",
  "/api/portal/practice",
] as const;

const REAL_SCOPE_PRACTICE = /^\/api\/portal\/practice(?:\/[^/]+\/(?:reset|restore-spec))?$/;

/** Mutations that stay allowed in practice though they are not practice requests: onboarding progress, and the session's own routes. */
export function practiceMutationAllowed(path: string): boolean {
  const bare = path.split(/[?#]/, 1)[0] ?? "";
  return practiceHeaderApplies(path) || REAL_SCOPE_PRACTICE.test(`/api/portal${bare}`) || bare === "/me/onboarding";
}

/** True when a request to `/api/portal${path}` (path as the API client builds it, query included) takes the header. */
export function practiceHeaderApplies(path: string): boolean {
  const full = `/api/portal${path.split(/[?#]/, 1)[0] ?? ""}`;
  if (REAL_SCOPE_PRACTICE.test(full)) return false;
  return PRACTICE_ROUTE_PREFIXES.some((p) => full === p || full.startsWith(`${p}/`));
}
